import { appEnv } from '@/app/config/env';
import { Clarity } from '@/app/libs/clarity/instance';

if (import.meta.env.PROD) {
  Clarity.init(appEnv.clarityId);
}
